import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import PageHeader from 'shared/page-header';
import Layout from '../../wrappers/layout';
// import IndicatorCard from './components/indicator-card';
import { userStore } from '../../store/UserStore';
import Loader from '../../shared/common/loader';
import CustomerHttp from './services/customer.service';
import { useHistory, useLocation } from 'react-router-dom';
import DashboardHttp from '../profile/services/profile.service';
import IndicatorCard from 'shared/common/indicator-card';
import plus from '../../assets/images/plus.svg';
import RedeemModal from './components/RedeemModal';
import Modal from 'react-modal';
import StaticModal from 'shared/common/modal/staticModal';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Pushnotification from '../login/services/login.service';
import { getMessaging, getToken } from 'firebase/messaging';
import { app, db, auth } from '../../firebaseConfig';
import { toast } from 'react-toastify';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';

interface PropsType {}

const CustomerPage: React.FC<PropsType> = () => {
  // eslint-disable-next-line
  const location = useLocation();
  const history = useHistory();
  const firstRender = useRef(true);
  let ID = new URLSearchParams(location.search).get('customerId');
  const [setCustomerId, setCustomer, setSelectedAccount] = userStore(
    (state: any) => [
      state.setCustomerId,
      state.setCustomer,
      state.setSelectedAccount,
    ]
  );
  const [user, setUser, setCustomers] = userStore((state: any) => [
    state.user,
    state.setUser,
    state.setCustomers,
  ]);
  const [loading, setLoading] = useState<any>(true);
  const [custLoading, setCustLoading] = useState<any>(true);
  const [customersResponse, setCustomersResponse] = useState<any>([]);
  const [customerID, setCustomerID] = useState(null);

  useEffect(() => {
    async function redirect() {
      await redirectCustomer(customerID);
    }
    if (customerID != null) {
      redirect();
    }
  }, [customerID]);

  const getProfile = async (customerId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomer(userData.data.data.customer);
        history.push(new URLSearchParams(location.search).get('returnUrl'));
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const redirectCustomer = async (customerId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomerId(customerId);
        setCustomer(userData.data.data.customer);
        setSelectedAccount(userData.data.data.customer.accounts[0]);
        // storeFCMToken();
        // The Buy Gold/Silver Bar redirect hand-off (/handle-redirect) stashes
        // a pending product code here before routing through /customers, since
        // customer/customerId must be hydrated (TermsGuard requires it) before
        // /buy-coins-bars can render. Stepper reads this same key to jump
        // straight to step 2 with the product pre-selected.
        // A /partner-checkout link opened before login is parked here and
        // resumed now that the session/customer is ready (valid for 15 min).
        let pending: string | null = null;
        try {
          const saved = JSON.parse(
            localStorage.getItem('pendingPartnerCheckout') || 'null'
          );
          if (
            saved?.url?.startsWith('/partner-checkout?') &&
            Date.now() - saved.at < 15 * 60 * 1000
          ) {
            pending = saved.url;
          }
        } catch (e) {}
        localStorage.removeItem('pendingPartnerCheckout');
        history.push(
          pending ||
            (localStorage.getItem('Product') ? '/buy-coins-bars' : '/dashboard')
        );
      }
    } catch (e: any) {
    } finally {
      setLoading(false);
    }
  };

  // const storeFCMToken = async () => {
  //   try {
  //     const messaging = getMessaging(app);
  //     const userId = user?.customers[0]?.user?.userId;

  //     // Retrieve the FCM token
  //     getToken(messaging)
  //       .then(async (token) => {
  //         const data = { token: token, user_id: userId };
  //         const storeToken = await Pushnotification.storeFcmToken(data);
  //         // console.log('FCM Token:', token);
  //       })
  //       .catch((error) => {
  //         console.error('Error getting FCM token:', error);
  //       });
  //     // const fcmtoken = localStorage.getItem('FCM_Token');
  //     // const userId = user?.customers[0]?.user?.userId;
  //     // const data = { token: fcmtoken, user_id: userId };
  //     // const storeToken = await Pushnotification.storeFcmToken(data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  /**
   *
   */

  const createIndCustomer = async (values) => {
    setCustLoading(true);
    try {
      const customer_data = {
        customerType: 'IND',
        displayName: values.displayName,
        kyc: {},
      };

      const cus_res: any = await CustomerOnboardingHttp.createCustomer(
        customer_data,
        values?.userId
      );

      if (cus_res.status === 200 && cus_res.data) {
        const account_data = {
          customerId: cus_res.data.data.customerId,
          pinCode: '400037',
          stateName: 'Maharashtra',
        };
        const acc_res: any = await CustomerOnboardingHttp.createAccount(
          account_data,
          user?.userId
        );
        if (acc_res.status === 200 && acc_res.data) {
          toast.success('New customer account has been created.');
          history.push('/dashboard');
        }
      }
      setCustLoading(false);
    } catch (e: any) {
      toast.error(e.data.errors[0].title);
      setCustLoading(false);
    }
  };

  // ****************
  const getUserProfile = async () => {
    setLoading(true);
    try {
      const res: any = await CustomerHttp.getUserProfile(user?.userId);
      if (res.status === 200 && res.data.data) {
        setCustomersResponse(res.data.data.customers);
        setCustomers(res.data.data.customers);
        setUser(res.data.data);
        setCustomerID(res.data.data.customers[0]?.customerId);
        if (res.data.data.customers?.length === 0) {

          // createIndCustomer(res.data.data);
    history.push('/customer-details');

        }
      }
      setLoading(false);
    } catch (e: any) {
      console.log(e.message);
      setLoading(false);
    }
  };

  const isSoleIndCreated = () => {
    return user?.customers.filter((customer) => customer.customerType == 'IND');
  };

  const onNewAccount = () => {
    if (isSoleIndCreated()?.length > 0) return;
    history.push('/customer/create');
  };

  // const onCustomerClick = (customer) => {
  //   if (customer.customerId) {
  //     redirectCustomer(customer.customerId);
  //   }
  // };

  // ********* New signup/login journey *******

  useEffect((): any => {
    setLoading(true);
    if (ID) {
      setCustomerId(ID);
      getProfile(ID);
    }
    getUserProfile();
    // createIndCustomer();
    // storeFCMToken();
    document.title = 'Customers - eBullion';
    // eslint-disable-next-line
  }, []);

  return (
    <Layout isLinkShow={false}>
      {/*<Toast/>*/}
      {loading || custLoading ? (
        <Loader />
      ) : (
        <div className='mt-3'>
          {/* {customersResponse.length === 0 && (
            <>
              <PageHeader
                mainTitle={`Hi ${user.displayName},` || ''}
                subTitle='Welcome to eBullion. Please create a new account to continue'
                isShowSub={false}
              />
              <Row>
                <Col md={12}>
                  <Row>
                    {customersResponse.length === 0 && (
                      <IndicatorCard
                        customClass='text-center p-3 c-main mb-4'
                        onClick={onNewAccount}
                        title='Create New Customer Account'
                        styles={{
                          color: 'white',
                          textAlign: 'left',
                        }}
                        backgroundColor='#301250'
                      >
                        <img src={plus} className='card-image' alt='' />
                      </IndicatorCard>
                    )}
                  </Row>
                </Col>
              </Row>
            </>
          )} */}
        </div>
      )}
      <RedeemModal />
      {/* <NomineeModal /> */}
    </Layout>
  );
};

export default CustomerPage;
